module.exports = __webpack_public_path__ + "img/715716_m.c340d4d0.jpg";